const CARDINAL = [
  { x: -1, y: 0 },
  { x: 1, y: 0},
  { x: 0, y: -1 },
  { x: 0, y: 1 }
];

const ORDINAL = [
  { x: -1, y: -1 },
  { x: 1, y: -1 },
  { x: -1, y: 1 },
  { x: 1, y: 1}
];

const Directions = {
  CARDINAL,
  ORDINAL,
  ALL: [...CARDINAL, ...ORDINAL],
  WEST: CARDINAL[0],
  EAST: CARDINAL[1],
  NORTH: CARDINAL[2],
  SOUTH: CARDINAL[3],
}

export default Directions;
